module.exports = __webpack_public_path__ + "img/adv_js.37767d09.png";